<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import * as Icon from "@heroicons/vue/24/solid";
const props = defineProps({ classic: Boolean });
const {
  reference,
  relatedQuote,
  canDeleteReference,
  isAnySectionEditing,
  scheduleSummary,
  setVersionAccepted,
  openCancelModal,
  openDeleteModal,
} = useReferenceWorkspace();
</script>

<template>
  <FormBox class="reference-header">
    <template #header>
      <div class="flex flex-wrap items-center gap-3">
        <span
          class="break-words text-xl font-semibold text-slate-900 dark:text-slate-100"
          >{{ reference.data.name }}</span
        >
        <span
          class="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em]"
          :class="
            isAnySectionEditing
              ? 'bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-200'
              : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300'
          "
        >
          {{ isAnySectionEditing ? "Editing Section" : "Viewing" }}
        </span>
      </div>
    </template>
    <template #nav>
      <button
        class="btn-plain bg-green-600"
        @click.prevent="setVersionAccepted"
        v-if="!reference.data.accepted_at"
      >
        <Icon.SparklesIcon class="icon" /> <span>Accept</span>
      </button>

      <button
        class="btn-plain bg-red-600"
        @click.prevent="openCancelModal"
        v-if="reference.data.accepted_at"
      >
        <Icon.MinusIcon class="icon" /> <span>Cancel</span>
      </button>

      <button
        v-if="canDeleteReference"
        data-testid="open-delete-reference-modal"
        class="btn-plain bg-red-700"
        @click.prevent="openDeleteModal"
      >
        <Icon.TrashIcon class="icon" /> <span>Delete</span>
      </button>
    </template>
    <div
      v-if="!props.classic"
      class="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-slate-600 dark:text-slate-300"
    >
      <span class="font-semibold text-slate-900 dark:text-slate-100">{{
        reference.data.txt || `#${reference.data.id}`
      }}</span>
      <router-link
        v-if="reference.data.customer?.id"
        :to="`/customer/${reference.data.customer.id}`"
        class="underline decoration-slate-300 underline-offset-4"
        >{{ reference.data.customer.company }}</router-link
      >
      <span>{{ reference.data.accepted_at ? "Accepted" : "Pending" }}</span>
      <span>{{ scheduleSummary.dateRange }}</span>
      <router-link
        v-if="relatedQuote?.id"
        :to="`/quotes/${relatedQuote.id}`"
        class="font-semibold text-sky-700 dark:text-sky-300"
        >Quote #{{ relatedQuote.id }}</router-link
      >
      <router-link
        v-if="reference.data.invoice?.id"
        :to="`/invoice/${reference.data.invoice.id}`"
        class="font-semibold text-sky-700 dark:text-sky-300"
        >Invoice #{{ reference.data.invoice.id }} ·
        {{
          reference.data.invoice.payment_status_label || "View invoice"
        }}</router-link
      >
    </div>
  </FormBox>
</template>
<style scoped>
.reference-header :deep(.header-container) {
  flex-wrap: wrap;
}
.reference-header :deep(.header-container > header) {
  min-width: min(100%, 18rem);
}
</style>
